import { createStore } from 'vuex';

import buths from './buths/buths';
import post from './blog/post';
import menus from './menus/menus';

export default createStore({
    modules: {
        buths,
        post,
        menus,
    }
})